module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino_esign_logo_dark-d89f32353a868477b39f492a40648ba8.svg";